import { t } from 'i18next';

export enum HostStatus {
  PENDING = 'PENDING',
  SETTING_UP = 'SETTING_UP',
  SCANNING = 'SCANNING',
  RETRIEVING_TRACE = 'RETRIEVING_TRACE',
  RETRIEVED_TRACE = 'RETRIEVED_TRACE',
  DOWNLOADING_TRACE = 'DOWNLOADING_TRACE',
  DOWNLOADED_TRACE = 'DOWNLOADED_TRACE',
  SUCCESS = 'SUCCESS',
  FAIL = 'FAIL',
  CANCELED = 'CANCELED',
}

export const getHostStatusLabel = (status: HostStatus): string => {
  const labels = {
    [HostStatus.PENDING]: t('hostStatus.pending'),
    [HostStatus.SETTING_UP]: t('hostStatus.settingUp'),
    [HostStatus.SCANNING]: t('hostStatus.scanning'),
    [HostStatus.RETRIEVING_TRACE]: t('hostStatus.retrievingTrace'),
    [HostStatus.RETRIEVED_TRACE]: t('hostStatus.retrievedTrace'),
    [HostStatus.DOWNLOADING_TRACE]: t('hostStatus.downloadingTrace'),
    [HostStatus.DOWNLOADED_TRACE]: t('hostStatus.downloadedTrace'),
    [HostStatus.SUCCESS]: t('hostStatus.success'),
    [HostStatus.FAIL]: t('hostStatus.fail'),
    [HostStatus.CANCELED]: t('hostStatus.canceled'),
  };

  return labels[status];
};
